// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__3kNU9","header":"MergedInvoice_header__2uNyz"};